import Card from '@/components/Card'
import Dropdown, { Item } from '@/components/form/Dropdown'
import { getYearBeforeCurrent, months } from '@/utils/date-format';
import React, { useEffect } from 'react'
import LeaveBalanceOverviewDataTable from './components/LeaveBalanceOverviewDataTable';

function LeaveBalancePage() {
  const [selectedYear, setSelectedYear] = React.useState<string>("");

  const yearOptions: Item[] = getYearBeforeCurrent().map((year) => ({
    label: year.toString(),
    value: year.toString(),
  }));

  useEffect(() => {
    setSelectedYear(new Date().getFullYear().toString());
  }, []);

  return (
    <div className="flex flex-col h-[100vh] w-full p-4 gap-4">
      <Card>
        <div className="flex gap-2 w-full flex-col p-5">
          <div className="font-bold text-2xl mb-4">View Employee's Leave Balance</div>
          <div className="mb-4 flex flex-col gap-3">
            <div className="font-bold  mt-2 text-xl">Select Year</div>
            <div className="text-sm text-gray-500">
              Select the year you want to view leave balance for.
            </div>
          </div>

          <Dropdown
            label="Year"
            items={yearOptions}
            selectedString={selectedYear}
            setSelectedString={setSelectedYear}
          />
        </div>
      </Card>

      <LeaveBalanceOverviewDataTable selectedYear={selectedYear} />

    </div>
  )
}

export default LeaveBalancePage
